// TODO: after add redux, this file must remove!

const data = {
	clientName: 'سعید خزائی',
	phone: '09380255332',
	address: 'تهران، خیابان لاله زار جنوبی، ',
	date: 'سه‌شنبه 25 آذر 1399 ساعت 21:00',
	package_name: 'اقتصادی - 1ساعت - 8 فریم دانلود',
	photographer: 'م . رضایی',
	package_cost: '159000',
	transportation_cost: '25000',
	tax: '0',
	current_balance: '10000',
	final_cost: '1000000',
};
export default data;
